export const version = 'kunde-v1.20.0-SNAPSHOT-71458b0cc2cfead3b9519576ae867b04d584001f';